export default [
  {
    text: 'Компетенции',
    to: { name: 'competences', query: { sort: 'events_count' } },
  },
];



// WEBPACK FOOTER //
// ./src/pages/menu.competences.js